import { apiClient } from './client';

export const openDqbApi = apiClient.injectEndpoints({
    endpoints: (builder) => ({
        openDqb: builder.mutation<void, { book_id: any }>({
            query: ({ book_id }) => ({
                url: '/api/openDqb',
                method: 'POST',
                body: { book_id },
            }),
        }),
    }),
});

export const { useOpenDqbMutation } = openDqbApi;
